import { useHeaders } from "ssr-hook";
import { useTitle } from "easy-page-router/react";

export function useHead({ title, description }: { title: string; description: string }) {
    useHeaders({
        lang: "cs",
        title,
        description,
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });
    useTitle(title);
}

export async function toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || "");
        reader.onerror = reject;
    });
}

export function getFileName(fullName: string, fullUrl: string): string {
    const url = fullUrl.split(".");
    const ext = url[url.length - 1];

    // TODO: error with docx base64
    if (ext.length > 10) return "";

    if (fullName.endsWith(`.${ext}`)) return fullName;

    return `${fullName}.${ext}`;
}

export function validateEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
